import { PixelBufferWebGL } from './PixelBufferWebGL';
var TICK_PERIOD = 10;
var FenceContextWebGL = /** @class */ (function () {
    function FenceContextWebGL(_gl) {
        this._gl = _gl;
        this.pool = [];
        this._tickerId = -1;
        this._tasks = [];
    }
    /**
     * Async read from PBO.
     * @see http://www.songho.ca/opengl/gl_pbo.html
     */
    FenceContextWebGL.prototype.readPixels = function (x, y, width, height) {
        var _this = this;
        var pbo = this.pool.pop() || new PixelBufferWebGL(this._gl);
        // only for RGBA
        pbo.bind(width * height * 4);
        var gl = this._gl;
        // read to PBO, this is asynce instruction
        gl.readPixels(x, y, width, height, gl.RGBA, gl.UNSIGNED_BYTE, 0);
        var fence = gl.fenceSync(gl.SYNC_GPU_COMMANDS_COMPLETE, 0);
        // return a promise that was used for requesting a data
        var p = new Promise(function (task) {
            _this._tasks.push({ task: task, pbo: pbo, fence: fence });
        });
        if (this._tickerId === -1) {
            // if we will use sync every time - we will spam GPU,
            // need use something in between
            this._tickerId = setInterval(this.tick.bind(this), TICK_PERIOD);
        }
        return p;
    };
    FenceContextWebGL.prototype.tick = function () {
        if (this._tasks.length === 0)
            return;
        var gl = this._gl;
        var tasks = this._tasks;
        for (var i = 0; i < this._tasks.length; i++) {
            var t = tasks[i];
            if (gl.getSyncParameter(t.fence, gl.SYNC_STATUS) === gl.SIGNALED) {
                t.task(t.pbo);
                gl.deleteSync(t.fence);
                tasks[i] = undefined;
            }
        }
        this._tasks = tasks.filter(function (e) { return !!e; });
        if (this._tasks.length === 0) {
            // stop ticker
            clearInterval(this._tickerId);
            this._tickerId = -1;
        }
    };
    FenceContextWebGL.prototype.release = function (pbo) {
        // push a PBO back to pool;
        if (pbo.alive) {
            this.pool.push(pbo);
        }
    };
    FenceContextWebGL.prototype.unboundAll = function () {
        PixelBufferWebGL.unboundAll();
    };
    FenceContextWebGL.prototype.dispose = function () {
        this._tasks = null;
        this.pool.forEach(function (e) { return e.dispose(); });
        this._gl = null;
    };
    FenceContextWebGL.isSupported = PixelBufferWebGL.isSuported;
    return FenceContextWebGL;
}());
export { FenceContextWebGL };
